import { render, staticRenderFns } from "./dataBoardS.vue?vue&type=template&id=777643f6&scoped=true"
import script from "./dataBoardS.vue?vue&type=script&lang=js"
export * from "./dataBoardS.vue?vue&type=script&lang=js"
import style0 from "./dataBoardS.vue?vue&type=style&index=0&id=777643f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777643f6",
  null
  
)

export default component.exports